export default "__VITE_ASSET__cldtuhfC__"